<template>
    <div class="content_main filemanage" v-loading="loading">
        <h2 class="title">文件管理</h2>
        <el-row class="search_demo">
            <el-col :span="7" class="search_filter">
                <label class="filter_title">搜索关键词</label>
                <el-input class="filter_item width_100 border_drop" v-model="searchData.keyword" placeholder="例如：合同编号，房号，租客名称" prefix-icon="el-icon-search"></el-input>
            </el-col>
            <el-col :span="7" class="search_filter">
                <label class="filter_title">起租时间</label>
                <el-date-picker
                    value-format='MM/dd/yyyy'
                  class="width_100 border_drop border_left_0"
                  v-model="searchData.RentStartTime"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>
            </el-col>
            <el-col :span="7" class="search_filter">
                <label class="filter_title" style="visibility: hidden;">结束日期</label>
                <el-date-picker
                    value-format='MM/dd/yyyy'
                 class="width_100 border_drop border_left_0"
                  v-model="searchData.RentStartTimeEnd"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>
            </el-col>
            <el-col :span="3" class="search_filter">
                <label class="filter_title" style="visibility: hidden;">搜索</label>
                <el-button class="search_btn" type="primary" @click="search()">筛选<i class="el-icon-search"></i></el-button>
            </el-col>
        </el-row>
        <div style="margin-top:40px" v-loading="loading2">
            <el-table
            :data="tableData"
            @expand-change="change"
            style="width: 100%">
            <el-table-column type="expand">
                <template slot-scope="scope">
                    <el-table
                    :data="scope.row.childList"
                    style="width: 100%">
                    <el-table-column
                        prop="FJName"
                        label="名称"
                        width="480">
                    </el-table-column>
                    <el-table-column
                        label="下载">
                        <template slot-scope="childScope">
                            <img class="filemanage_down_img" @click="downFile(childScope.row)" src="http://landlord.jrechina.com/images/xiazai.png">
                        </template>
                    </el-table-column>
                    </el-table>
                </template>
            </el-table-column>
            <el-table-column
                label="名称"
                width="330">
                <template slot-scope="scope">
                    <img style="float:left;top:8px" src="http://landlord.jrechina.com/images/hetong.png" alt="">
                    <span class="fileManage_label_he">合同编号:{{scope.row.No}}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="RentStartTime"
                label="起租日期"
                width="230">
            </el-table-column>
            <el-table-column
                prop="C_COMName"
                label="樓盤信息">
            </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            searchData:{
                keyword: '',
                RentStartTime: '',
                rentData2: '',
                RentStartTimeEnd:'',
                Action:'GetAllContracts'
            },
            tableData:[],
            loading:false,
            loading2:false
            
        }
    },
    methods:{
        search(){
            this.loading = true;
            this.$get('/Handler/HTGL.ashx',this.searchData,data => {
                this.loading = false;
                this.tableData = data || [];
            } , error => {
                this.loading = false;
            });
        },
        change(event,tab){
            this.loading2 = true;
            let params = {
                Action:'GetContractFJ',
                ContractID:event.ID
            }
            this.$get('/Handler/HTGL.ashx',params,data => {
                for(var i = 0 ; i < this.tableData.length ; i++){
                    if(this.tableData[i].ID == event.ID){
                        this.tableData[i].childList = data;
                    }
                }
                // let timer = setTimeout(() => {
                //     this.loading2 = false;
                //     clearTimeout(timer);
                // },500);
                this.loading2 = false;
            },error => {
                this.loading2 = false;
            });
        },
        downFile(row){
            window.location =  this.url + '/Handler/HTGL.ashx?Action=DownFJ&url=' + row.Address;
        }
    },
    created(){
        this.search();
    }
}
</script>

<style scoped>
.content_main.filemanage{
    width: 80%;
    padding: 25px;
}
.content_main.filemanage .title{
    font-size: 16px;
    color: #95A5A6;
    margin-bottom: 20px;
}
.filemanage .search_filter{
    display: block;
    /* float: left; */
    /* width: 260px; */
}
.filemanage .search_filter:last-child{
    /* float: left;width: 100px; */
}
.filemanage .filter_title{
    display: block;
    color: #95A5A6;
    margin-bottom: 5px;
}
.filemanage .search_filter .filter_item{
    display: inline-block;
    /* width: 260px; */
}
.filemanage .search_filter .el-input__inner{
    border-radius: 0;
    /* width: 260px; */
}
.filemanage .search_filter .search_btn{
    display: inline-block;
    border-radius: 0;
    height: 40px;
    line-height: 40px;
    width: 100px;
    padding: 0;
}
.filemanage .search_filter .search_btn .el-icon-search{
 font-size: 25px;
 position: relative;
 left: 5px;
 top: 3px;
}
.filemanage .fileManage_label_he{
    padding: 0 0 0 10px;
    position: relative;
    top: 2px;
}
.filemanage .filemanage_down_img{
    cursor: pointer;

}
</style>



// WEBPACK FOOTER //
// src/pages/filesManage/filesManage.vue